export default function refreshArray<T>(target: T[], source: T[] | null | undefined) {
    if (!source) {
        target.splice(0);
    } else {
        if (source.length < target.length) {
            target.splice(source.length);
        }

        while (source.length > target.length) {
            target.push((undefined as unknown) as T);
        }

        for (let i = 0; i < source.length; i++) {
            if (target[i] !== source[i]) {
                target[i] = source[i];
            }
        }
    }
}
